module.exports = __webpack_public_path__ + "img/pecans-bg-992w.5c691ab7.jpg";